import { render, staticRenderFns } from "./add_zt.vue?vue&type=template&id=8ff41f7a&"
import script from "./add_zt.vue?vue&type=script&lang=js&"
export * from "./add_zt.vue?vue&type=script&lang=js&"
import style0 from "./add_zt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports